module.exports = __webpack_public_path__ + "images/icon-headingbar.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-headingbar.png
// module id = SMVL
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13